import { Box, Paper } from '@mui/material';
import { useState } from 'react';

import { CodeHighlighter } from 'modules/common/components/CodeHighlighter';
import { CopyCodeButton } from 'modules/chains/components/CopyCodeButton';

import { CodeExampleTabs } from './components/CodeExampleTabs';
import {
  CodeType,
  mapLanguageByCodeType,
  getAAPISnippetByCodeType,
} from './const';
import { useMultichainCodeExampleStyles } from './useMultichainCodeExampleStyles';

interface MultichainCodeExampleProps {
  url?: string;
}

export const MultichainCodeExample = ({ url }: MultichainCodeExampleProps) => {
  const [codeType, setCodeType] = useState(CodeType.ANKRJS);

  const { classes } = useMultichainCodeExampleStyles();

  const code = getAAPISnippetByCodeType(codeType, url);

  return (
    <Paper className={classes.root}>
      <Box className={classes.codeSampleWrapper}>
        <div className={classes.sandboxHeader}>
          <CodeExampleTabs
            classNameTab={classes.tab}
            classNameTabsWrapper={classes.tabsWrapper}
            setCodeType={setCodeType}
          />
          <CopyCodeButton className={classes.copyButton} code={code} />
        </div>
        <CodeHighlighter
          className={classes.codeSample}
          code={code}
          language={mapLanguageByCodeType[codeType]}
        />
      </Box>
    </Paper>
  );
};
